import React from 'react';
import ReviewCard from './ReviewCard';

function FeedView({ 
  feed, 
  savedReviewIds,
  onViewCreators,
  onSaveReview,
  onUnsaveReview,
  onViewCreator,
  onUpgrade,
  onPhotoClick
}) {
  if (feed.length === 0) {
    return (
      <div className="space-y-6" data-testid="feed-view">
        <div className="text-center py-16">
          <p className="text-xl text-gray-500 mb-4">Start saving spots you want to try 🍽️</p>
          <button
            onClick={onViewCreators}
            className="bg-primary text-white px-6 py-3 rounded-button font-semibold hover:shadow-hover"
            data-testid="discover-creators-button"
          >
            Discover Creators
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="feed-view">
      {feed.map(review => (
        <ReviewCard
          key={review.review_id}
          review={review}
          onPhotoClick={(index) => onPhotoClick(review, index)}
          onSave={() => onSaveReview(review.review_id, review.restaurant.name)}
          onUnsave={() => onUnsaveReview(review.review_id, review.restaurant.name)}
          isSaved={savedReviewIds.has(review.review_id)}
          onViewCreator={onViewCreator}
          onUpgrade={(creatorId, creatorName) => onUpgrade(creatorId, creatorName, 7.0)}
        />
      ))}
    </div>
  );
}

export default FeedView;
